/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneContentLock from 'base/components/standalone/ContentLock';

export const DynamicStandaloneContentLock = StandaloneContentLock;
export type DynamicStandaloneContentLockProps = PropsFromComponent<typeof StandaloneContentLock>;

export const DynamicStandaloneContentLockWith = (extras: DynamicStandaloneExtras): typeof StandaloneContentLock => {
    return function DynamicStandaloneContentLock(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ContentLock');
        return <StandaloneContentLock {...mergeProps({ options: { theme } }, props)} />;
    }
}